import AdvantageDisadvantageIcon from './AdvantageDisadvantageIcon';

export default AdvantageDisadvantageIcon;
export { AdvantageDisadvantageIcon };
